'use client'

import * as lottieHeart from '../../../resources/lottie/donate-popup-heart.json' with { type: 'json' }
import Link from 'next/link'
import { Button } from '@/components/Button'
import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { cn } from '@/utilities/cn'
import { useAppStorage } from '@/lib/client/app-storage/useAppStorage'

export default function DonatePopup() {
  const { state } = useAppStorage()
  const [hidden, setHidden] = useState<boolean>(true)
  useEffect(() => {
    if (!state) return
    if (state.pageLoads > 0 && (state.pageLoads - 1) % 10 === 0) {
      setHidden(false)
    }
  }, [state, state?.pageLoads])
  const Lottie = dynamic(() => import('react-lottie'), { ssr: false })
  return hidden ? null : (
    <div
      className={cn(
        'fixed right-0 bottom-0 p-2 sm:p-0 sm:right-4 sm:bottom-4 w-full sm:max-w-lg',
        'animate-in slide-in-from-bottom duration-1000 ease-out',
      )}
    >
      <div className={'bg-white border-2 border-primary shadow rounded-xl p-4'}>
        <div className={'flex gap-2'}>
          <div className={'mb-1'}>
            <p className={'text-sm font-semibold'}>
              JeugdFilms bestaat dankzij vrijwilligers en donateurs
            </p>
            <p className={'text-sm'}>
              Jouw bijdrage helpt ons jonge talenten te inspireren en maatschappelijke thema&apos;s
              bespreekbaar te maken.
            </p>
          </div>
          <div className={'flex size-[75px] sm:size-[100px]'}>
            <Lottie
              options={{ animationData: lottieHeart, loop: true }}
              isClickToPauseDisabled={true}
              width={100}
              height={100}
            />
          </div>
        </div>
        <div className={'flex flex-col gap-2'}>
          {/*<div className={'bg-white border border-stone-200 h-6 w-48 rounded-full overflow-hidden'}>*/}
          {/*  <div className={'bg-progress-stripes w-20 h-full rounded-full border-2 border-white'}>*/}

          {/*  </div>*/}
          {/*</div>*/}
          <div className={'flex gap-2'}>
            <Link
              href={
                'https://www.gofundme.com/f/xytzme-doneer-voor-filmprojecten-op-scholen/donate?attribution_id=undefined&utm_campaign=unknown&utm_medium=customer&utm_source=website_widget'
              }
              target={'_blank'}
            >
              <Button size={'sm'}>Doneer</Button>
            </Link>
            <Button size={'sm'} variant={'outline'} onClick={() => setHidden(true)}>
              Niet nu
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
